import { render } from "./BaseLinkedinAccount.vue?vue&type=template&id=4527fdc6"
import script from "./BaseLinkedinAccount.vue?vue&type=script&lang=js"
export * from "./BaseLinkedinAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__